import { Component, OnInit } from "@angular/core"; import { Location } from "@angular/common";
import { ItemService } from 'src/app/services/item-service';

@Component({
  selector: 'app-error',
  templateUrl: './app.error.component.html',
})
export class AppErrorComponent implements OnInit {

  constructor(private itemService: ItemService) {}

  ngOnInit() {
  }

  openStatusPage() {
    window.open('https://hamelconstruction.betteruptime.com/fr-ca', '_blank');
  }
}
